import React from "react";

const Loading = () => {
  return (
    <div className="containerSubRight">
      <div className="loader-container1">
        <div className="loader1"></div>
      </div>
    </div>
  );
};

export default Loading;
